/**
 * notify.js
 * Thin wrapper around ElNotification that pins all toasts to the bottom-right
 * corner and provides the same .success / .error / .warning / .info API as ElMessage.
 */
import { ElNotification } from 'element-plus'

const DEFAULTS = {
    position: 'bottom-right',
    duration: 3000,
    showClose: true,
}

const notify = {
    success (message, options = {}) {
        return ElNotification({ ...DEFAULTS, type: 'success', message, ...options })
    },
    error (message, options = {}) {
        return ElNotification({ ...DEFAULTS, type: 'error', duration: 4000, message, ...options })
    },
    warning (message, options = {}) {
        return ElNotification({ ...DEFAULTS, type: 'warning', message, ...options })
    },
    info (message, options = {}) {
        return ElNotification({ ...DEFAULTS, type: 'info', message, ...options })
    },
}

export default notify
